(function () {
  const hello = () => {
    console.log(`
  ____  _      __                             _       _
 / __ \\| |    /_/                            | |     | |
| |  | | | __ _     _ __ ___  _   _ _ __   __| | ___ | |
| |  | | |/ _\` |   | '_ \` _ \\| | | | '_ \\ / _\` |/ _ \\| |
| |__| | | (_| |_  | | | | | | |_| | | | | (_| | (_) |_|
 \\____/|_|\\__,_( ) |_| |_| |_|\\__,_|_| |_|\\__,_|\\___/(_)
               |/
`);

    console.log(`🤙🏼`);
  };

  const mediaQueryMotionReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const title = () => {
    const titleItems = Array.from(document.querySelectorAll('header .title span'));
    const total = titleItems.length;

    setInterval(() => {
      const activeElem = titleItems.filter((element) => element.classList.contains('active'))[0];
      const activeIndex = titleItems.findIndex((element) => element.classList.contains('active'));
      const nextIndex = activeIndex + 1 < total ? activeIndex + 1 : 0;

      activeElem.classList.remove('active');
      titleItems[nextIndex].classList.add('active');
    }, 2000);
  };

  const tilt = () => {
    VanillaTilt.init(document.querySelectorAll('.card'), {
      max: 10,
      speed: 300,
      glare: true,
      'max-glare': 1,
    });
  };

  hello();

  if (!(!mediaQueryMotionReduce || mediaQueryMotionReduce.matches)) {
    title();
    tilt();
  }

  mediaQueryMotionReduce.addEventListener('change', () => {
    if (!mediaQueryMotionReduce.matches) {
      title();
      tilt();
    }
  });
})();
